<template>
  <div class="flex flex-row space-x-2 sm:space-x-3">
    <div
      class="flex-grow sm:flex-grow-0 sm:w-20 border-b-2"
      :class="{
        'border-primary': code[inputIndex] !== '' && !invalid,
        'border-danger': invalid,
      }"
      v-for="(input, inputIndex) in length"
      :key="inputIndex">
      <input
        class="w-full text-3xl md:text-6xl px-3 py-2 text-center placeholder-geyser"
        :class="{
          'text-primary': code[inputIndex] !== '' && !invalid,
          'text-danger': invalid,
        }"
        placeholder="0"
        maxlength="1"
        type="number"
        pattern="[0-9]*"
        inputmode="decimal"
        v-inputmask="{
          mask: '9',
          placeholder: '',
          showMaskOnHover: false,
          showMaskOnFocus: false,
        }"
        v-focus="inputIndex === index"
        @input="($event) => onInput($event, inputIndex)"
        @keyup.delete="($event) => onDelete($event, inputIndex)"
        v-model="code[inputIndex]"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invalid: {
      type: [Boolean, Number],
      required: false,
      default: false,
    },
  },
  data() {
    return {
      length: 6,
      index: 0,
      code: [],
    };
  },
  directives: {
    focus: {
      componentUpdated(node, obj) {
        if (obj.value) {
          node.focus();
        }
      },
    },
  },
  methods: {
    onInput(event, inputIndex) {
      this.index = inputIndex;
      if (event.target.value !== '') {
        this.index += 1;
      }
      if (!this.code.includes('')) {
        this.$emit('input', this.code.join(''));
      } else {
        this.$emit('input', null);
      }
    },
    onDelete(event, inputIndex) {
      if (event.target.value === '' && inputIndex > 0) {
        this.index = inputIndex - 1;
      }
    },
  },
  created() {
    this.code = new Array(6).fill('');
  },
};
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
</style>
